import React, { useEffect, useState } from "react";
import MudrexIcon from "../MudrexIcon/MudrexIcon";

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  isDisabled?: boolean;
  id: number;
  openAccordionId: number;
  setOpenAccordionId: React.Dispatch<React.SetStateAction<number>>;
  isCompleted: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false,
  isDisabled,
  id,
  openAccordionId,
  setOpenAccordionId,
  isCompleted,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    if (id !== openAccordionId) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, [id, openAccordionId]);

  return (
    <div className="rounded-lg shadow mb-4 bg-gradient-background-medium">
      <button
        onClick={() => {
          if (!isDisabled) {
            if (!isOpen) {
              setOpenAccordionId(id);
            }
            setIsOpen(!isOpen);
          }
        }}
        className={`w-full flex items-center justify-between px-4 py-3 text-gray-900 text-left font-medium ${
          isDisabled ? "pointer-events-none" : "pointer-events-auto"
        }`}
      >
        <div className="flex items-center">
          <span>{title}</span>
          {isCompleted && (
            <div className="bg-status-positive rounded-[8px] w-[16px] h-[16px] ml-[6px] flex items-center justify-center">
              <MudrexIcon icon="Check" size={14} color="#FFFFFF" />
            </div>
          )}
        </div>
        <svg
          className={`transform transition-transform ${
            isOpen ? "rotate-180" : ""
          } bg-white w-8 h-8 rounded-2xl`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke={isDisabled ? "#D1D5DB" : "currentColor"}
          strokeWidth={1}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {isOpen && <div>{children}</div>}
    </div>
  );
};

export default Accordion;
